import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import * as accountActions from '../../actions/accountActions';
import * as messageAlert from '../../actions/messageAlertAction';
import { smartLoaderService } from '../../services/domain/smartLoaderService';

import Logo from '../common/Logo';
import CustomButton from '../common/CustomButton';
import * as SwHelper from '../../service-worker/sw-helper';
import { redirect } from '../../utils/HttpUtils.js';
import { Input } from '@netexknowledge/smart-components';
import routerHistory from '../../routerHistory';

import $ from 'jquery';
import LoginGoogle from './LoginGoogle';
import { getSkinFromStorageOrDefault, getTokenExpired, setTokenExpired } from '../../shared';
import { ROUTES, MAX_LENGTH_VARIABLES } from '../../const';
import { PropTypes } from 'prop-types';
import * as DownloadInstallerService from './DownloadInstaller/DownloadInstallerService';
import { isElectronApp } from '../../services/crossPlatform/crossPlatformService';

// import CustomIcon from '../common/CustomIcon'; // used by the hidden app download buttons
import { isGoogleSSOConfigured } from '../../utils/google/GClassroomUtils';
import LoginAzure from './LoginAzure';

export class Login extends React.Component {
  constructor(props) {
    super(props);
    this.loginHandler = this.loginHandler.bind(this);
    this.tokenExpired = getTokenExpired() ? JSON.parse(getTokenExpired()) : false;
    this.state = {
      email: '',
      emailError: '',
      password: '',
      passwordError: '',
      guestCode: ''
    };
    this.handleGuestCodeChange = this.handleGuestCodeChange.bind(this);
    this.guestCodeSubmitHandler = this.guestCodeSubmitHandler.bind(this);
  }

  static propTypes = {
    indexTransition: PropTypes.any,
    messageAlert: PropTypes.object,
    accountActions: PropTypes.object,
    externalLoginURL: PropTypes.string,
    hideAppDownloadLink: PropTypes.bool,
    redirectAfterLogin: PropTypes.string
  };

  componentDidMount() {
    const { indexTransition } = this.props;
    if (indexTransition) {
      $('#wrapperBackground').addClass('background-color-transparent-opacity');
    }
    SwHelper.newSessionActions();
  }
  componentDidUpdate() {
    const { messageAlert } = this.props;
    if (this.tokenExpired) {
      messageAlert.error(I18n.t('login.tokenExpired'));
      setTokenExpired(JSON.stringify(false));
      this.tokenExpired = false;
    }
  }

  handleUsernameChange = event => {
    this.setState({ email: event.target.value });
  };

  handlePasswordChange = event => {
    this.setState({ password: event.target.value });
  };

  handleGuestCodeChange(event) {
    this.setState({ guestCode: event.target.value.toUpperCase().replace(/\s/g, '') });
  }

  guestCodeSubmitHandler(e) {
    e.preventDefault();
    const { guestCode } = this.state;
    if (guestCode) {
      routerHistory.push(`${ROUTES.GUEST_LANDING}/${guestCode}`);
    }
  }

  validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email) && email.length <= MAX_LENGTH_VARIABLES.EMAIL;
  }

  loginHandler(e) {
    e.preventDefault();
    const { messageAlert, accountActions, externalLoginURL, redirectAfterLogin } = this.props;
    const { email, password } = this.state;

    if (!this.validateEmail(email)) {
      this.setState({ emailError: I18n.t('error.invalidEmail') });
      return;
    }

    if (password.length > MAX_LENGTH_VARIABLES.PASSWORD) {
      messageAlert.error(I18n.t('login.error'));
      return;
    }

    if (!email.length) {
      this.setState({ emailError: I18n.t('error.valueRequired') });
    }

    if (!password.length) {
      this.setState({ passwordError: I18n.t('error.valueRequired') });
    }

    if (email.length && password.length) {
      this.setState({ emailError: '', passwordError: '' });

      smartLoaderService.open();

      accountActions.login(email, password, externalLoginURL).then(() => {
        redirect(window.location.origin + redirectAfterLogin).then(() => {
          accountActions.clearRedirectAfterLogin();
          smartLoaderService.close();
        });
      });
    }
  }

  render() {
    const { indexTransition, externalLoginURL, redirectAfterLogin } = this.props;
    const { email, emailError, password, passwordError, guestCode } = this.state;
    let transparent = !indexTransition ? 'background-color-transparent-opacity' : '';
    let theme = getSkinFromStorageOrDefault();
    let colors = theme.colors;
    let centerContainer = isElectronApp() || !DownloadInstallerService.isValidOs();
    let isBackendLogin = !externalLoginURL;

    return (
      <div
        className={`column xlarge-6 large-8 medium-10 small-12 content align-center ${
          centerContainer ? '' : 'top-margin'
        }`}
      >
        <div className={`row box background-color-transparent ${transparent} align-center`} id="wrapperBackground">
          <div className="row small-12 align-top">
            <div className="column">
              <div className="column small-12 text-center">
                <Logo customCss="logo-transparent" />
              </div>
              <div>
                <div className="column xlarge-offset-2 xlarge-8 large-offset-3 large-6 medium-offset-2 medium-8 small-12 text-center">
                  {isBackendLogin && isGoogleSSOConfigured() && <LoginGoogle />}
                  <LoginAzure redirectUrl={window.location.origin + redirectAfterLogin} />
                </div>
                <div
                  className="column xlarge-offset-2 xlarge-8 large-offset-3 large-6 medium-offset-2 medium-8 small-12"
                  style={{ float: 'left' }}
                >
                  <div className="line">
                    <div className="small-5 columns">
                      <hr />
                    </div>
                    <div className="column small-2 text-center o_center align-self-middle">
                      <span>{I18n.t('common.or')}</span>
                    </div>
                    <div className="small-5 columns">
                      <hr />
                    </div>
                  </div>
                </div>
              </div>
              <form onSubmit={this.loginHandler}>
                <div className="column xlarge-offset-2 xlarge-8 large-offset-3 large-6 medium-offset-2 medium-8 small-12 text-center">
                  <div style={{ marginBottom: '24px' }}>
                    <Input
                      id="username"
                      type="text"
                      value={email}
                      onChange={this.handleUsernameChange}
                      placeholder={I18n.t('login.email')}
                      state={emailError ? 'error' : ''}
                      helper={emailError ? emailError : ''}
                    />
                  </div>
                  <Input
                    id="password"
                    type="password"
                    value={password}
                    onChange={this.handlePasswordChange}
                    placeholder={I18n.t('login.password')}
                    state={passwordError ? 'error' : ''}
                    helper={passwordError ? passwordError : ''}
                  />
                  {isBackendLogin && (
                    <Link id="login-forget-link" to={ROUTES.FORGET_PASSWORD}>
                      <p className="forget-password-question">{I18n.t('login.forgetPassword')}</p>
                    </Link>
                  )}
                  <div>
                    <CustomButton
                      color={colors.btnSuccess}
                      colorHover={colors.btnSuccessHover}
                      id="loginButton"
                      className="button secondary expanded"
                      value={I18n.t('login.loginButton')}
                    />
                  </div>
                </div>
              </form>
              {isBackendLogin && (
                <div className="row align-self-bottom text-center guest-login-clear-floats">
                  <Link id="login-register-link" to={ROUTES.JOIN}>
                    <p className="bottom-link" data-cy="registerLink">
                      {' '}
                      {I18n.t('login.register')}
                    </p>
                  </Link>
                </div>
              )}
              <div
                className="column xlarge-offset-2 xlarge-8 large-offset-3 large-6 medium-offset-2 medium-8 small-12"
                style={{ float: 'left' }}
              >
                <div className="line">
                  <div className="small-5 columns">
                    <hr />
                  </div>
                  <div className="column small-2 text-center o_center align-self-middle">
                    <span>{I18n.t('common.or')}</span>
                  </div>
                  <div className="small-5 columns">
                    <hr />
                  </div>
                </div>
              </div>
              <div className="column small-12">
                <div className="guest-access-block">
                  <p className="guest-access-title">{I18n.t('guest.login.title')}</p>
                  <form onSubmit={this.guestCodeSubmitHandler} className="guest-code-row">
                    <div className="guest-code-input-wrapper guest-code-input-wrapper--compact">
                      <Input
                        id="guestCodeLogin"
                        type="text"
                        value={guestCode}
                        onChange={this.handleGuestCodeChange}
                        placeholder="CODIGO-INVITADO"
                      />
                    </div>
                    <CustomButton
                      id="guestCodeButton"
                      className="button guest-code-button"
                      value={I18n.t('guest.login.button')}
                      manuallyDisabled={!guestCode.length}
                    />
                  </form>
                  <p className="guest-access-helper">{I18n.t('guest.login.helper')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*{hideAppDownloadLink ? null : <DownloadInstaller/>}*/}
        {/* App download buttons hidden for now
        <div className="row box small-12 align-center download-installer-wrapper">
          <div className="column xlarge-6 large-6 medium-6 small-6">
            <a
              className="download-installer"
              target={'_blank'}
              href="https://play.google.com/store/apps/details?id=com.netex.smartclassroom.corporate"
            >
              <CustomIcon name="cellphone-backside" size={24} />
              <span>Android</span>
            </a>
          </div>
          <div className="column xlarge-6 large-6 medium-6 small-6">
            <a
              className="download-installer"
              target={'_blank'}
              href="https://apps.apple.com/es/app/smart-classroom/id1458375556"
            >
              <CustomIcon name="cellphone-backside" size={24} />
              <span>iOS</span>
              <br></br>
            </a>
          </div>
        </div>
        */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    indexTransition: state.router.indexTransition,
    redirectAfterLogin: state.router.redirectAfterLogin,
    externalLoginURL: state.account.configuration.externalLoginURL,
    hideAppDownloadLink: state.account.configuration.hideAppDownloadLink,
    i18n: state.i18n
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
